var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 172,
    viewBox: "0 0 212 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 172,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.536 55.8999C178.814 55.8999 181.472 58.5951 181.472 61.9199C181.472 65.2447 178.814 67.9399 175.536 67.9399H141.616C144.894 67.9399 147.552 70.6351 147.552 73.9599C147.552 77.2847 144.894 79.9799 141.616 79.9799H160.272C163.55 79.9799 166.208 82.6751 166.208 85.9999C166.208 89.3247 163.55 92.0199 160.272 92.0199H151.645C147.511 92.0199 144.16 94.7151 144.16 98.0399C144.16 100.256 145.856 102.263 149.248 104.06C152.526 104.06 155.184 106.755 155.184 110.08C155.184 113.405 152.526 116.1 149.248 116.1H78.864C75.5857 116.1 72.928 113.405 72.928 110.08C72.928 106.755 75.5857 104.06 78.864 104.06H45.792C42.5137 104.06 39.856 101.365 39.856 98.0399C39.856 94.7151 42.5137 92.0199 45.792 92.0199H79.712C82.9904 92.0199 85.648 89.3247 85.648 85.9999C85.648 82.6751 82.9904 79.9799 79.712 79.9799H58.512C55.2337 79.9799 52.576 77.2847 52.576 73.9599C52.576 70.6351 55.2337 67.9399 58.512 67.9399H92.432C89.1537 67.9399 86.496 65.2447 86.496 61.9199C86.496 58.5951 89.1537 55.8999 92.432 55.8999H175.536ZM175.536 79.9799C178.814 79.9799 181.472 82.6751 181.472 85.9999C181.472 89.3247 178.814 92.0199 175.536 92.0199C172.258 92.0199 169.6 89.3247 169.6 85.9999C169.6 82.6751 172.258 79.9799 175.536 79.9799Z",
    fill: "#DFE5EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9594 101.27C92.8736 101.88 92.8293 102.503 92.8293 103.137C92.8293 110.442 98.726 116.364 106 116.364C113.274 116.364 119.171 110.442 119.171 103.137C119.171 102.503 119.126 101.88 119.041 101.27H151V130.693C151 132.52 149.526 134 147.707 134H64.2927C62.4742 134 61 132.52 61 130.693V101.27H92.9594Z",
    fill: "#E8F7E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.268 100.932C120.268 108.846 113.88 115.261 106 115.261C98.1198 115.261 91.7317 108.846 91.7317 100.932C91.7317 100.675 91.7384 100.42 91.7517 100.167H61L71.4932 69.0086C71.9455 67.6653 73.2003 66.7612 74.6123 66.7612H137.388C138.8 66.7612 140.054 67.6653 140.507 69.0086L151 100.167H120.248C120.262 100.42 120.268 100.675 120.268 100.932Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.18 101.984C118.18 108.099 112.727 114.159 106 114.159C99.273 114.159 93.8197 108.099 93.8197 101.984C93.8197 101.786 93.8255 100.487 93.8368 100.291H70.8781L79.8356 78.4182C80.2218 77.3803 81.293 76.6816 82.4983 76.6816H129.502C130.707 76.6816 131.778 77.3803 132.164 78.4182L141.122 100.291H118.163C118.175 100.487 118.18 101.786 118.18 101.984Z",
    fill: "#FFF7DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3719 100.394V129.591C62.3719 130.656 63.2319 131.52 64.2927 131.52H147.707C148.768 131.52 149.628 130.656 149.628 129.591V100.394L139.207 69.4501C138.943 68.6665 138.211 68.1392 137.388 68.1392H74.6123C73.7886 68.1392 73.0567 68.6665 72.7928 69.4501L62.3719 100.394Z",
    stroke: "#88C3E1",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3659 99.8296C80.6865 99.8296 85.3493 99.8296 90.3542 99.8296C92.4135 99.8296 92.4135 101.283 92.4135 102.034C92.4135 109.339 98.4459 115.261 105.887 115.261C113.329 115.261 119.361 109.339 119.361 102.034C119.361 101.283 119.361 99.8296 121.42 99.8296H148.805M68.2151 99.8296H70.8781H68.2151Z",
    stroke: "#88C3E1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 41.7428L121.366 55.4695M105.012 37V55.4695V37ZM76.3658 41.7428L88.5483 55.4695L76.3658 41.7428Z",
    stroke: "#FDC517",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPayer);
export default __webpack_public_path__ + "static/media/EmptyPayer.7c3648420bdc404c1ab6d46e0f715f66.svg";
export { ForwardRef as ReactComponent };